import script from "./UploadRequestPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadRequestPanel.vue?vue&type=script&lang=ts&setup=true"

import "./UploadRequestPanel.vue?vue&type=style&index=0&id=2b041337&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b041337"]])

export default __exports__